<template>
    <component
        :is="tag"
        v-if="wrap"
        :role="role"
    >
        <slot />
    </component>
    <template v-else>
        <slot />
    </template>
</template>
<script setup>
defineProps({
    wrap: {
        type: Boolean,
        required: true,
    },
    tag: {
        type: String,
        default: 'div',
    },
    role: {
        type: String,
        default: null,
    },
});
</script>
